// 暫存註冊過程的[手機]和[Email]

const getDefaultState = () => {
  return {
    formattedNumber: "",
    countryCode: "",
    mobile: "",
    email: ""
  };
};

//init state
const state = getDefaultState();

const mutations = {
  SET_REGISTER: (state, info) => {
    state.formattedNumber = info?.formattedNumber || "";
    state.countryCode = info?.countryCode || "";
    state.mobile = info.mobile;
    state.email = info.email;
  },
  SET_REGISTER_EMAIL: (state, email) => {
    state.email = email;
  }
};

const actions = {
  setRegister({ commit }, payload) {
    commit("SET_REGISTER", payload);
  },
  setRegisterEmail({ commit }, email) {
    commit("SET_REGISTER_EMAIL", email);
  }
};

const getters = {
  formattedNumber: state => state.formattedNumber,
  countryCode: state => state.countryCode,
  mobile: state => state.mobile,
  email: state => state.email
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
